import { ModelBase } from 'store/model-base';

import { PlanSku, ShopCategory } from 'core/constants';

export class Plan extends ModelBase {
    public static storeName: string = 'plans';

    public id: PlanSku;
    public planGroup: string;
    public details: ProductFeature[];
    public category: ShopCategory;

    public name: string;
    public dataUnlimited: boolean;
    public variants: object[];

    public get isForPhone(): boolean {
        return this.category === ShopCategory.DEVICE;
    }

    public get isForTablet(): boolean {
        return this.category === ShopCategory.TABLET;
    }
}
